import React, { memo } from 'react'
import PageTitle from '@/components/PageTitle'
import styles from './style.module.scss'

function Map(): JSX.Element {
  return (
    <div className={styles.Map}>
      <picture>
        <source srcSet="/address_hongkong.png" media="(min-width: 956px)" />
        <img src="/address_hongkong.png" />
      </picture>
    </div>
  )
}

function Contact(): JSX.Element {
  const infoList = [
    {
      title: '华东商务合作',
      briefTitle: '华东商务',
      name: '王先生',
      wechat: 'wanga3t',
      qq: '2993916065',
      email: 'nonowang@123u.com',
    },
    {
      title: '华南商务合作',
      briefTitle: '华南商务',
      name: '崔女士',
      wechat: 'yulia_cui',
      qq: '1181696437',
      email: 'yuliacui@123u.com',
    },
    {
      title: '人力资源',
      briefTitle: '人力资源',
      name: '李女士',
      wechat: 'Ashley_Lii-',
      qq: '3285659422',
      email: 'huanle-hr@123u.com',
    },
  ]

  return (
    <>
      <Map></Map>
      <div className={styles.ContactContainer}>
        <div className={styles.PCInfo}>
          <div style={{ width: '100%' }}>
            <PageTitle title="联系我们" subTitle="Contact Us" />
          </div>
          <div className={styles.CardWrap}>
            {infoList.map((info) => (
              <div className={styles.Item} key={info.name}>
                <div className={styles.ItemTitle}>
                  {/* <img src="https://tc-cdn.123u.com/official-website/contact/logo.png" /> */}
                  <div className={styles.VerticalLine}></div>
                  {info.title}
                </div>
                <div className={styles.ItemContentWrap}>
                  <div className={styles.ItemContent}>
                    <div>{info.name}</div>
                    <div>微信：{info.wechat}</div>
                    <div>QQ：{info.qq}</div>
                    <div>邮箱：{info.email}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.MobileInfo}>
          {infoList.map((info) => (
            <div className={styles.Info} key={info.name}>
              <div className={styles.Left}>{info.briefTitle}</div>
              <div className={styles.Right}>
                <div>{info.name}</div>
                <div>微信：{info.wechat}</div>
                <div>QQ：{info.qq}</div>
                <div>邮箱：{info.email}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default memo(Contact)
